import {every} from 'lodash/fp'
import {isArray, keyBy} from 'lodash/fp'
import {categories} from './categories'

const {food, heating, electricity} = categories
const answer = (value, modifiers, meta) => ({value, modifiers: isArray(modifiers) ? modifiers : [modifiers], meta})
const modifier = (emissions, amount) => ({emissions: isArray(emissions) ? emissions : [emissions], amount})

export const questions = [
  {
    preamble: 'In 2 minutes, you will know how your climate impact compares to the average American.',
    type: 'zip',
    text: 'Start by giving us your zip code.',
    help: 'A home\'s climate impact depends greatly upon your climate and how much clean energy your State uses.',
    answers: keyBy('value', [
      answer('AL', [
        modifier(electricity, 0.892180306302238),
        modifier(heating, 0.431041212269362),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('AK', [
        modifier(electricity, 1.07970661682784),
        modifier(heating, 2.06125840173474),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('AZ', [
        modifier(electricity, 0.981233290870761),
        modifier(heating, 0.343002034984344),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('AR', [
        modifier(electricity, 1.0468642869434),
        modifier(heating, 0.704045549734044),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('CA', [
        modifier(electricity, 0.935971538112817),
        modifier(heating, 0.684368750742655),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('CO', [
        modifier(electricity, 1.15453710910543),
        modifier(heating, 1.47406154190536),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('CT', [
        modifier(electricity, 0.80671333178604),
        modifier(heating, 1.89618600009685),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('DE', [
        modifier(electricity, 1.10124514799609),
        modifier(heating, 0.920718865376614),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('DC', [
        modifier(electricity, 1.01910043487362),
        modifier(heating, 1.17201589868966),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('FL', [
        modifier(electricity, 1.02408295226079),
        modifier(heating, 0.0581230959838125),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('GA', [
        modifier(electricity, 0.944203391765162),
        modifier(heating, 0.672940162831224),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('HI', [
        modifier(electricity, 1.19907950615818),
        modifier(heating, 0.0674518666742903),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('ID', [
        modifier(electricity, 0.737265863776709),
        modifier(heating, 1.11616836359871),
        modifier('powerForWaterSupply', 0.859432387312187)
      ]),
      answer('IL', [
        modifier(electricity, 0.924422147892768),
        modifier(heating, 1.89674803971298),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('IN', [
        modifier(electricity, 1.30486194216127),
        modifier(heating, 1.2539264014896),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('IA', [
        modifier(electricity, 0.931112230217545),
        modifier(heating, 1.47096411426558),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('KS', [
        modifier(electricity, 1.07862667488192),
        modifier(heating, 1.37446916277027),
        modifier('powerForWaterSupply', 1.29069282136895)
      ]),
      answer('KY', [
        modifier(electricity, 1.37791328427969),
        modifier(heating, 0.732602965032184),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('LA', [
        modifier(electricity, 0.94736243725285),
        modifier(heating, 0.450447930837966),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('ME', [
        modifier(electricity, 0.688968831338126),
        modifier(heating, 1.71116622355164),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('MD', [
        modifier(electricity, 0.972938319374794),
        modifier(heating, 0.990379512515192),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('MA', [
        modifier(electricity, 1.0117832358843),
        modifier(heating, 1.92445290609234),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('MI', [
        modifier(electricity, 1.03031901553075),
        modifier(heating, 1.98109376902041),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('MN', [
        modifier(electricity, 0.948227174858879),
        modifier(heating, 1.62491631189508),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('MS', [
        modifier(electricity, 0.969015120861307),
        modifier(heating, 0.538245288472368),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('MO', [
        modifier(electricity, 1.27131482105679),
        modifier(heating, 1.04982242149846),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('MT', [
        modifier(electricity, 1.08248791052524),
        modifier(heating, 1.49266081019742),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('NE', [
        modifier(electricity, 1.05675765255991),
        modifier(heating, 1.36849976489931),
        modifier('powerForWaterSupply', 1.29069282136895)
      ]),
      answer('NV', [
        modifier(electricity, 1.01396648063431),
        modifier(heating, 0.848579273658201),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('NH', [
        modifier(electricity, 0.658394103599197),
        modifier(heating, 1.64586848090087),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('NJ', [
        modifier(electricity, 0.892310694657065),
        modifier(heating, 1.56436239726243),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('NM', [
        modifier(electricity, 1.21879639075653),
        modifier(heating, 1.04457537684961),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('NY', [
        modifier(electricity, 0.818503308404655),
        modifier(heating, 1.53737921313468),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('NC', [
        modifier(electricity, 0.940835254637374),
        modifier(heating, 0.500069585989343),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('ND', [
        modifier(electricity, 1.28948351904536),
        modifier(heating, 1.44011166174755),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('OH', [
        modifier(electricity, 1.19231141520372),
        modifier(heating, 1.47328443943333),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('OK', [
        modifier(electricity, 1.09830832767373),
        modifier(heating, 1.00840930264617),
        modifier('powerForWaterSupply', 1.29069282136895)
      ]),
      answer('OR', [
        modifier(electricity, 0.648669197421805),
        modifier(heating, 0.67473941777607),
        modifier('powerForWaterSupply', 0.859432387312187)
      ]),
      answer('PA', [
        modifier(electricity, 0.990484378250649),
        modifier(heating, 1.4605750044694),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('RI', [
        modifier(electricity, 1.0563525749551),
        modifier(heating, 1.98146609084744),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('SC', [
        modifier(electricity, 0.745884402191601),
        modifier(heating, 0.376853586271406),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('SD', [
        modifier(electricity, 0.766551116201554),
        modifier(heating, 1.23303947832234),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('TN', [
        modifier(electricity, 0.945143239322543),
        modifier(heating, 0.612325758320481),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('TX', [
        modifier(electricity, 0.908529111246729),
        modifier(heating, 0.444020952139395),
        modifier('powerForWaterSupply', 1.29069282136895)
      ]),
      answer('UT', [
        modifier(electricity, 1.31196857386838),
        modifier(heating, 1.33854530350586),
        modifier('powerForWaterSupply', 1.62381747356706)
      ]),
      answer('VT', [
        modifier(electricity, 0.4799637395175),
        modifier(heating, 1.96476201546295),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('VA', [
        modifier(electricity, 0.955982732109097),
        modifier(heating, 0.745229090915973),
        modifier('powerForWaterSupply', 0.945325542570952)
      ]),
      answer('WA', [
        modifier(electricity, 0.629476269072421),
        modifier(heating, 0.72000129532116),
        modifier('powerForWaterSupply', 0.859432387312187)
      ]),
      answer('WV', [
        modifier(electricity, 1.45512339285807),
        modifier(heating, 0.970399244686186),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('WI', [
        modifier(electricity, 1.0655281555148),
        modifier(heating, 1.61616890740098),
        modifier('powerForWaterSupply', 0.26036449638286)
      ]),
      answer('WY', [
        modifier(electricity, 1.39913904740259),
        modifier(heating, 1.62541427752651),
        modifier('powerForWaterSupply', 0.859432387312187)
      ]),
    ]),
  },
  {
    type: 'button',
    variant: 'single-line',
    text: 'How many people age 13 or older live in your house?',
    help: 'Almost a third of your impact will come from energy used in the home. So the more people you have under your roof, the less your own personal impact.',
    answers: [
      answer('1', modifier([...heating, ...electricity], 2.4)),
      answer('2', modifier([...heating, ...electricity], 1.2)),
      answer('3', modifier([...heating, ...electricity], 0.8)),
      answer('4', modifier([...heating, ...electricity], 0.6)),
      answer('5', modifier([...heating, ...electricity], 0.48)),
      answer('6+', modifier([...heating, ...electricity], 0.4)),
    ],
  },
  {
    type: 'radio',
    text: 'How often do you eat processed snack foods and candy?',
    help: 'Processed foods take a lot of energy to produce and often contain palm oil, which is a leading cause of deforestation.',
    answers: [
      answer('Almost Never', modifier('snackFoods', .035714)),
      answer('Occasionally', modifier('snackFoods', .142857)),
      answer('A few times a week', modifier('snackFoods', .5)),
      answer('About once a day', modifier('snackFoods', 1)),
      answer('A couple times a day', modifier('snackFoods', 2)),
      answer('All the time', modifier('snackFoods', 3)),
    ],
  },
  {
    type: 'radio',
    text: 'How many times a week do you eat beef or lamb?',
    help: 'Red meat is responsible for as much as 10% of an average American\'s climate impact, or even more if you are a big meat eater. This is largely due to the way cows and sheep digest their food, producing large quantities of methane.',
    answers: [
      answer('I never eat red meat', modifier('beefAndLamb', 0)),
      answer('Rarely', modifier('beefAndLamb', .057624)),
      answer('Once per week', modifier('beefAndLamb', .230496)),
      answer('A few times a week', modifier('beefAndLamb', .691489)),
      answer('Almost every day', modifier('beefAndLamb', 1.382979)),
      answer('More than once a day', modifier('beefAndLamb', 2.12766)),
    ],
  },
  {
    type: 'radio',
    text: 'How many times a week do you eat pork?',
    help: 'Pork products (ham, bacon, sausage) don\'t result in as much methane as beef, but they still make a significant contribution to your climate impact.',
    answers: [
      answer('I never eat pork', modifier('pork', 0)),
      answer('Rarely', modifier('pork', 0.070899)),
      answer('Once per week', modifier('pork', 0.283595)),
      answer('A few times a week', modifier('pork', 0.850785)),
      answer('Almost every day', modifier('pork', 1.701571)),
      answer('More than once a day', modifier('pork', 2.617801)),
    ],
  },
  {
    type: 'radio',
    text: 'How many times per week do you eat chicken or turkey?',
    help: 'Poultry products have even less impact than pork, but Americans eat a lot more of it, making it a significant contributor to your climate impact.',
    answers: [
      answer('I never eat poultry', modifier('chickenAndTurkey', 0)),
      answer('Rarely', modifier('chickenAndTurkey', 0.044038)),
      answer('Once per week', modifier('chickenAndTurkey', 0.176152)),
      answer('A few times a week', modifier('chickenAndTurkey', 0.528455)),
      answer('Almost every day', modifier('chickenAndTurkey', 1.056911)),
      answer('More than once a day', modifier('chickenAndTurkey', 1.626016)),
    ],
  },
  {
    type: 'button',
    text: 'How much eggs and dairy do you consume?',
    help: 'The average Americans has 2-3 servings of dairy and eggs per day. Dairy products include the milk that goes in your cereal and your frappuccino, as well as cheese, ice cream, yogurt, and butter.',
    answers: [
      answer('Almost none', modifier('dairyAndEggs', 0.028571)),
      answer('A little', modifier('dairyAndEggs', 0.4)),
      answer('Average amount', modifier('dairyAndEggs', 1)),
      answer('A lot', modifier('dairyAndEggs', 1.428671)),
    ],
  },
  {
    type: 'button',
    text: 'How much of your food ends up going to waste each week?',
    help: 'Preventing food waste is one of the biggest ways we can make a difference on climate change. The average American throws out about 1/4 of their food, representing about 14 million tonnes of climate pollution per year.',
    answers: [
      answer('Almost none', modifier([...food], 0.777)),
      answer('A little does', modifier([...food], 0.88955)),
      answer('About 1/4', modifier([...food], 1.002)),
      answer('1/3 or more', modifier([...food], 1.102)),
    ],
  },
  {
    type: 'button',
    text: 'How much of your waste do you recycle?',
    help: 'By recycling plastic, metal, glass, and paper you are helping to reduce our total climate impact, as it takes much less energy to recycle these materials than it does to manufacture new materials.',
    answers: [
      answer('Almost all', modifier('solidWaste', 0.38111)),
      answer('More than 1/2', modifier('solidWaste', 0.623636)),
      answer('About 1/3', modifier('solidWaste', 1.039394)),
      answer('Less than 1/4', modifier('solidWaste', 2.286667)),
    ],
  },
  {
    type: 'button',
    text: 'How many bags of garbage does your household throw out each week?',
    help: 'The average home throws away 2-3 kitchen-sized bags of garbage per week. Disposing of our trash (by landfills or burning) has a big climate impact, so the less we throw out the less pollution is produced from our garbage. Composting vegetable scraps is a great way to reduce the amount of your garbage.',
    answers: [
      answer('Almost none', modifier('solidWaste', 0.198965)),
      answer('About 1', modifier('solidWaste', 0.497413)),
      answer('2 - 3 bags', modifier('solidWaste', 0.994827)),
      answer('3 - 4 bags', modifier('solidWaste', 1.392758)),
      answer('4 - 5 bags', modifier('solidWaste', 1.790688)),
      answer('Over 5 bags', modifier('solidWaste', 2.387585)),
    ],
  },
  {
    type: 'button',
    text: 'Do you use much water for the lawn, garden, and plants?',
    help: 'About a third of a typical family\'s water use is for lawn and garden.',
    answers: [
      answer('Yes', modifier('powerForWaterSupply', 1.292)),
      answer('No', modifier('powerForWaterSupply', 0.702)),
    ],
  },
  {
    type: 'radio',
    text: 'What type of home do you live in?',
    help: 'When it comes to heating, freestanding homes use the most energy. Not only because they tend to be larger, but because they don\'t share walls or floors with other homes. Apartments are the most efficient type of home.',
    answers: [
      answer('Single Family Home', [
        modifier('spaceHeating', 1.155083),
        modifier('waterHeating', 1.154928),
      ]),
      answer('Condo or Townhouse', [
        modifier('spaceHeating', 0.976253),
        modifier('waterHeating', 0.955716),
      ]),
      answer('Duplex or Fourplex', [
        modifier('spaceHeating', 1.030426),
        modifier('waterHeating', 0.907103),
      ]),
      answer('Apartment Building', [
        modifier('spaceHeating', 0.560789),
        modifier('waterHeating', 0.572139),
      ]),
      answer('Mobile Home', [
        modifier('spaceHeating', 0.585399),
        modifier('waterHeating', 0.736395),
      ]),
    ],
  },
  {
    type: 'radio',
    text: 'How big is your home?',
    help: 'The smaller the home, the easier it is to heat and cool.',
    answers: [
      answer('Small', [
        modifier('spaceHeating', 0.651495),
        modifier('cooling', 0.493956),
      ], '(under 1000 sq. ft)'),
      answer('Average', [
        modifier('spaceHeating', 0.827068),
        modifier('cooling', 0.969753),
      ], '(1000 - 2000 sq. ft)'),
      answer('Above Average', [
        modifier('spaceHeating', 1.210857),
        modifier('cooling', 1.172339),
      ], '(2000 - 3000 sq. ft)'),
      answer('Large', [
        modifier('spaceHeating', 1.489815),
        modifier('cooling', 1.291283),
      ], '(3000 - 4000 sq. ft)'),
      answer('Very Large', [
        modifier('spaceHeating', 1.759670),
        modifier('cooling', 1.928658),
      ], '(above 4000 sq. ft)'),
    ],
  },
  {
    type: 'button',
    text: 'How well insulated is your home?',
    help: 'The more insulation you have, the easier it is to heat and cool your home.',
    answers: [
      answer('Hardly insulated', modifier(['spaceHeating', 'cooling'], 1.333333)),
      answer('Not very well', modifier(['spaceHeating', 'cooling'], 1.176471)),
      answer('About average', modifier(['spaceHeating', 'cooling'], 1.000)),
      answer('Well-insulated', modifier(['spaceHeating', 'cooling'], 0.869565)),
    ],
  },
  {
    type: 'radio',
    text: 'How high do you set your thermostat in the winter?',
    help: 'According to the Department of Energy just setting your thermostat down 4 degrees in the winter can reduce your heating bill by more than 10%.',
    answers: [
      answer('I turn it way down to save money', modifier('spaceHeating', .7)),
      answer('I turn it down a few degrees', modifier('spaceHeating', .85)),
      answer('I keep it about average temperature', modifier('spaceHeating', 1.000)),
      answer('I turn it up a few degrees', modifier('spaceHeating', 1.15)),
    ],
  },
  {
    type: 'button',
    text: 'How much AC do you use in the summer?',
    help: 'Air conditioning is one of the biggest drains on the power grid in the summer months. Turning down the AC at night (or all the way off) can greatly reduce your energy bill.',
    answers: [
      answer('Almost none', modifier('cooling', 0.1)),
      answer('A little AC', modifier('cooling', 0.7)),
      answer('Average Amount', modifier('cooling', 1)),
      answer('A lot of AC', modifier('cooling', 1.3)),
    ],
  },
  {
    type: 'radio',
    text: 'What type of refrigerator do you have?',
    help: 'Refrigerators are the most energy-hogging appliances we have. Swapping an older refrigerator for a new EnergyStar-rated fridge can reduce this impact by as much as 75%',
    answers: [
      answer('Pre-2000 Fridge', modifier('mainRefrigerator', 1.540453)),
      answer('Standard Fridge', modifier('mainRefrigerator', 0.607335)),
      answer('Side-by-side Fridge', modifier('mainRefrigerator', 0.740022)),
      answer('New Energy-Efficient Fridge', modifier('mainRefrigerator', 0.418554)),
    ],
  },
  {
    type: 'button',
    text: 'Do you have an extra fridge or freezer unit?',
    help: 'Nearly half of U.S. homes have an extra refrigerator or freezer unit, and often these are older energy-hogging appliances.',
    answers: [
      answer('Yes', modifier('extraFridge', 2)),
      answer('No', modifier('extraFridge', 0)),
    ],
  },
  {
    type: 'button',
    text: 'Roughly how many LED bulbs do you use in your home?',
    help: 'New LED light bulbs look almost like regular bulbs, but are more energy-efficient than those fluorescentor incandescent bulbs. They also last 10 times longer. ',
    answers: [
      answer('A few LEDs', modifier('lighting', 1.000)),
      answer('About half', modifier('lighting', 0.675676)),
      answer('Mostly LED', modifier('lighting', 0.5)),
      answer('Almost all LED', modifier('lighting', 0.324324)),
    ],
  },
  {
    type: 'button',
    text: 'On a typical day how many hours is your TV turned on?',
    help: 'Some people leave their TV\'s turned on all day long, not realizing just how much energy they consume.',
    answers: [
      answer('never on', modifier('tv', 0.05)),
      answer('2 hrs or so', modifier('tv', 0.5)),
      answer('4 hrs or so', modifier('tv', 0.9)),
      answer('6 hrs or so', modifier('tv', 1.3)),
      answer('8 hrs or so', modifier('tv', 1.7)),
      answer('10 hrs or so', modifier('tv', 2.1)),
      answer('12 hrs or so', modifier('tv', 2.5)),
      answer('on all the time', modifier('tv', 3.2)),
    ],
  },
  {
    type: 'radio',
    text: 'Do you purchase renewable power or generate your own solar power?',
    help: 'Even if you don\'t have solar panels on your roof, you can get in on the solar game by getting a portable charging unit or even purchasing Renewable Energy Credits (RECs).',
    answers: [
      answer('No I Don\'t', modifier(electricity, 1.004954)),
      answer('Small Solar Charger', modifier(electricity, .999266)),
      answer('Full Solar Rooftop', modifier(electricity, .442180)),
      answer('Purchase RECs', modifier(electricity, .100495)),
    ],
  },
  {
    type: 'radio',
    text: 'Do you own or rent your home?',
    help: 'It takes a lot of energy to construct and manufacture all the elements that go into a home. When someone buys a newer home (defined as being built after 1970) they are taking on a part of this climate impact.',
    answers: [
      answer('I rent my home', modifier('primaryHomes', 0.028197)),
      answer('I own a post-1970 home', modifier('primaryHomes', 2.84792)),
      answer('I own an older home', modifier('primaryHomes', 0.281972)),
    ],
  },
  {
    type: 'button',
    text: 'Do you own a second home?',
    help: 'Appoximately 11 million familes in the U.S. own more than one home. For those people, we add an additional climate impact for the embodied energy of these homes.',
    answers: [
      answer('Yes', modifier('secondaryHomes', 2.209925)),
      answer('No', modifier('secondaryHomes', 0)),
    ],
  },
  {
    type: 'button',
    text: 'How much shopping do you do for clothes, gifts, and other products?',
    help: 'It takes energy to make everything, so the less you buy the lighter your impact on the planet.',
    answers: [
      answer('A little bit', modifier('manufacturedGoods', 0.5)),
      answer('Medium amount', modifier('manufacturedGoods', 1)),
      answer('Quite a bit', modifier('manufacturedGoods', 1.5)),
      answer('All the time', modifier('manufacturedGoods', 2)),
    ],
  },
  {
    type: 'radio',
    text: 'Do you own or lease an automotive vehicle?',
    help: 'It takes a lot of energy to manufacture all the components that go into a new car or truck. When someone buys a newer vehicle (defined as being built in the past 10 years) they are taking on a part of this climate impact.',
    answers: [
      answer('I own a new vehicle (post-2005)', modifier('vehicleManufacturing', 2.916869)),
      answer('I lease a newer vehicle (post-2005)', modifier('vehicleManufacturing', 1.458434)),
      answer('I own an older vehicle', modifier('vehicleManufacturing', 0.153519)),
      answer('I don\'t own a vehicle', modifier('vehicleManufacturing', 0.015602)),
    ],
  },
  {
    type: 'number',
    text: 'How many minutes do you spend driving in a car or other vehicle on a typical day?',
    help: 'This includes time when you are a passenger. The average American spends about 100 minutes per day.',
    answers: [
      answer('Total minutes', modifier('transportation', x => x / 101)),
    ]
  },
  {
    type: 'radio',
    text: 'What type of vehicle do you usually use during that time?',
    help: 'If you own a car or truck, select the vehicle you use most frequently. If you don\'t own a car, select the type of vehicle you would choose on occasion to get around.',
    answers: [
      answer('Train or Bus', modifier('transportation', 0.306061)),
      answer('Motorcycle', modifier('transportation', 0.367273)),
      answer('Electric Vehicle', modifier('transportation', 0.202000)),
      answer('Hybrid or Micro Car', modifier('transportation', 0.480952)),
      answer('Compact Car', modifier('transportation', 0.735883)),
      answer('Standard Car / Uber', modifier('transportation', 0.897778)),
      answer('Luxury / Large Car', modifier('transportation', 1.122222)),
      answer('Truck or Large SUV', modifier('transportation', 1.2625)),
    ],
  },
  {
    type: 'button',
    text: 'How much of that time are you ridesharing with another person?',
    help: 'If you frequently drive another passenger or are a passenger yourself, the carbon pollution associated with your trip is greatly reduced. But this does not include times when you hire a Taxi or Uber to drive you.',
    answers: [
      answer('Very rarely', modifier('transportation', 1.267)),
      answer('Occasionally', modifier('transportation', 1.000)),
      answer('Half the time', modifier('transportation', 0.667)),
      answer('Very Frequently', modifier('transportation', 0.444)),
    ],
  },
  {
    type: 'number',
    text: 'How many nights in the past year did you spend in a hotel, motel or Airbnb?',
    help: 'Hotels, Motels or Airbnbs should be thought of as a "home away from home" and thus the occupant is responsible for the energy used in their rooms.',
    answers: [
      answer('Number of nights',  modifier('hotelEnergy', x => x / 6.624)),
    ]
  },
  {
    type: 'button',
    text: 'How often do you go on a cruise or travel by motor boat?',
    help: 'Boat transportation, including cruises and recreational boating (motorized only), represent a significant climate impact for some people.',
    answers: [
      answer('Never', modifier('boatTravel', 0)),
      answer('Occasionally', modifier('boatTravel', 0.333)),
      answer('Every Month', modifier('boatTravel', 0.667)),
      answer('Every Week', modifier('boatTravel', 1)),
    ],
  },
  {
    type: 'number',
    text: 'How many roundtrip air flights did you take in the last 12 months?',
    help: 'Approximate the number and duration of your airline trips in the past year. If your trip has two or more legs, each is considered as an additional flight. ',
    answers: [
      answer('Quick commuter trips', modifier('airCommuter', x => x * 0.18848376 / 0.088951), 'Typically these are 1-2 hour flights.'),
      answer('Short haul trips', modifier('airShort', x => x * 0.487 / 0.123033), 'For example, Los Angeles to Dallas direct.'),
      answer('Medium-haul trips', modifier('airMedium', x => x * 0.808 / 0.123033), 'For example, Los Angeles to New York direct.'),
      answer('Long-haul trips', modifier('airLong', x => x * 1.371 / 0.045465), 'For example, Los Angeles to London direct.'),
      answer('Extra-long international trips', modifier('airExtraLong', x => x * 2.579 / 0.005052), 'For example, Los Angeles to Dubai direct.'),
    ],
  },
  {
    type: 'number',
    text: 'What percentage of the time did you fly first or business class?',
    help: 'Because a premium class seat on an airplane takes about double the space of a typical economy seat, it can add significantly to a person\'s total climate impact.',
    answers: [
      answer('Percent of the time', modifier([
        'airCommuter',
        'airShort',
        'airMedium',
        'airLong',
        'airExtraLong',
      ], x => x * .00998 + 1), 'Enter a number from 0 to 100.'),
    ],
    validator: answer => every(num => num >= 0 && num <= 100, answer)
  },
  {
    type: 'number',
    text: 'What percentage of the time did you fly private jet?',
    help: 'Flying on a private or chartered jet is becoming increasingly popular and comes with a dramatically increased climate impact.',
    answers: [
      answer('Percent of the time', modifier([
        'airCommuter',
        'airShort',
        'airMedium',
        'airLong',
        'airExtraLong',
      ], x => x * .06495 + 1), 'Enter a number from 0 to 100.'),
    ],
    validator: answer => every(num => num >= 0 && num <= 100, answer)
  }
]



// WEBPACK FOOTER //
// ./src/data/questions.js